import React from 'react';
import './ConstructionPage.css'; // Optional: for custom styling
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const ConstructionPage = () => {
  const navigate = useNavigate();
  const handleViewProjects = () => {
    navigate('/#contact'); // Adjust the path as needed
  };

  return (
    <div className="construction-page">
      <Helmet>
        <title>Construction | AnalyticaNova</title>
        <meta name="description" content="Learn about AnalyticaNova’s mission to empower data-driven decisions in urban development." />
      </Helmet>

        <header className="construction-nav-bar">
          <nav className="construction-nav-links">
            <Link to="/" className="construction-nav-link">Home</Link>
            <div className="construction-dropdown">
              <span className="construction-dropbtn">Verticals</span>
              <div className="construction-dropdown-content">
                <Link to="/construction">Construction</Link>
                <Link to="/healthcare">Healthcare</Link>
              </div>
            </div>
          </nav>
        </header>
      {/* Hero Section */}
      <section className="hero-split">
        <div className="hero-content">
          <h1>India's Leading Platform for Construction Market Intelligence</h1>
          <p>Unlock actionable insights to drive growth and impact across the infrastructure sector.</p>
          <button className="cta-button" onClick={handleViewProjects}>View Projects</button>
        </div>
        <div className="hero-image">
          <img src="/dashboard.png" alt="Dashboard" />
        </div>
      </section>
      {/* Services Section */}
      <section className="services">
        <h2>Our Services</h2>
        <div className="service-cards">
          <div className="card">
            <h3>Discover High-Value Project Leads</h3>
            <p>Stay ahead with curated opportunities across public and private construction domains.</p>
          </div>
          <div className="card">
            <h3>Analyze & Size Market Potential</h3>
            <p>Make informed decisions with data-driven forecasts and regional breakdowns.</p>
          </div>
          <div className="card">
            <h3>Connect with Key Decision Makers</h3>
            <p>Build strategic relationships with developers, consultants, and government stakeholders.</p>
          </div>
          <div className="card">
            <h3>Optimize Your Sales & Marketing Workflow</h3>
            <p>Streamline specifications, outreach, and conversion with precision targeting.</p>
          </div>
          <div className="card">
            <h3>Benchmark Against Competitors</h3>
            <p>Track industry movements and position your brand with confidence.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ConstructionPage;

  // return (<ProjectTable />);


